import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../client";

interface KmcAuthRequestDto {
  plusInfo?: string;
}

interface KmcAuthRequestResponse {
  success: boolean;
  data: {
    trCert: string;
    certNum: string;
    reqDate: string;
    trUrl: string;
  };
}

export const usePostKmcAuthRequest = () => {
  return useMutation({
    mutationFn: async (data: KmcAuthRequestDto) => {
      const response = await apiClient.post<KmcAuthRequestResponse>(
        "/kmc/auth/request",
        data
      );
      return response.data;
    },
  });
};
